import _ from 'lodash';

export const TEMPLATE_GAIN_RATIO = {
  BIG_SIZE: (334 / 146) * (5 / 0.5) * (146 / 83.39),
  SMALL_SIZE: (334 / 98) * (5 / 0.5) * (98 / 83.39),
};

/**
 * Applies a bulk template-swap action to the pending beat and swap change lists of the RR heat map. Returns an empty result when neither cells nor a template are selected, otherwise deep-clones every change list and, for each selected template cell or selected cell template, inserts, retargets or drops an entry in the bulk swap list while purging matching entries from the beat-change, reset and swap lists.
 *
 * @param input - Carries activeButton, the bulk and reset change lists, beatChanges, swapBeatChanges, listSelectedCells, selectedTemplate and newTemplateInfo.
 * @returns The updated clones of the bulk beat, reset, beat-change, reset-swap, swap and bulk-swap lists, or an empty result when nothing is selected.
 */
export const handleUpdateBulkActionSwap = (input: any) => {
  const {
    activeButton,

    bulkBeatsChange,
    beatChanges,
    resetBulkBeatsChanges,

    bulkSwapChanges,
    resetBulkSwapChanges,
    swapBeatChanges,

    listSelectedCells,
    selectedTemplate,
    newTemplateInfo,
  } = input;

  if (_.isEmpty(listSelectedCells) && _.isEmpty(selectedTemplate)) {
    return {};
  }

  const cloneBulkBeatChange: any[] = _.cloneDeep(bulkBeatsChange || []);
  const cloneResetBeats: any[] = _.cloneDeep(resetBulkBeatsChanges || []);
  const cloneBeatChanges: any[] = _.cloneDeep(beatChanges || []);

  const cloneResetSwapList: any[] = _.cloneDeep(resetBulkSwapChanges || []);
  const cloneSwapBeatChanges: any[] = _.cloneDeep(swapBeatChanges || []);
  const cloneBulkSwapChanges: any[] = _.cloneDeep(bulkSwapChanges || []);

  if (_.isEmpty(listSelectedCells)) {
    if (!_.isEmpty(selectedTemplate)) {
      _.forEach(selectedTemplate?.rrHeatMapCells, (cell) => {
        const existtedItem = _.find(
          cloneBulkSwapChanges,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
        const isNotChange = selectedTemplate.id === newTemplateInfo?.id;
        if (existtedItem) {
          if (isNotChange) {
            _.remove(
              cloneBulkSwapChanges,
              (x) => x.originalTemplateId === selectedTemplate.id && x.cellId === cell.id,
            );
          } else {
            existtedItem.templateId = newTemplateInfo?.id;
          }
        } else if (!isNotChange) {
          cloneBulkSwapChanges.push({
            originalTemplateId: selectedTemplate.id,
            cellId: cell.id,
            templateId: newTemplateInfo?.id,
            beatType: activeButton,
          });
        }
        _.remove(
          cloneResetBeats,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
        _.remove(
          cloneBeatChanges,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
        _.remove(
          cloneResetSwapList,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
        _.remove(
          cloneSwapBeatChanges,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
        _.remove(
          cloneBulkBeatChange,
          (item) => item.originalTemplateId === selectedTemplate.id && item.cellId === cell.id,
        );
      });
    }
  } else if (_.isEmpty(selectedTemplate)) {
    _.forEach(listSelectedCells, (cell) => {
      if (!_.isEmpty(cell?.templates)) {
        _.forEach(cell?.templates, (template) => {
          const existtedItem = _.find(
            cloneBulkSwapChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          const isNotChange = template.id === newTemplateInfo?.id;
          if (existtedItem) {
            if (isNotChange) {
              _.remove(
                cloneBulkSwapChanges,
                (x) => x.originalTemplateId === template.id && x.cellId === cell.id,
              );
            } else {
              existtedItem.templateId = newTemplateInfo?.id;
            }
          } else if (!isNotChange) {
            cloneBulkSwapChanges.push({
              originalTemplateId: template.id,
              cellId: cell.id,
              templateId: newTemplateInfo?.id,
              beatType: activeButton,
            });
          }
          _.remove(
            cloneResetBeats,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneBeatChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneResetSwapList,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneSwapBeatChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneBulkBeatChange,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
        });
      } else {
        // in case no template (beats type is not V/S) then do nothing
      }
    });
  } else {
    _.forEach(listSelectedCells, (cell) => {
      _.forEach(cell?.templates, (template) => {
        if (template.id === selectedTemplate.id) {
          const existtedItem = _.find(
            cloneBulkSwapChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          const isNotChange = template.id === newTemplateInfo?.id;
          if (existtedItem) {
            if (isNotChange) {
              _.remove(
                cloneBulkSwapChanges,
                (x) => x.originalTemplateId === template.id && x.cellId === cell.id,
              );
            } else {
              existtedItem.templateId = newTemplateInfo?.id;
            }
          } else if (!isNotChange) {
            cloneBulkSwapChanges.push({
              originalTemplateId: template.id,
              cellId: cell.id,
              templateId: newTemplateInfo?.id,
              beatType: activeButton,
            });
          }
          _.remove(
            cloneResetBeats,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneBeatChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneResetSwapList,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneSwapBeatChanges,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
          _.remove(
            cloneBulkBeatChange,
            (item) => item.originalTemplateId === template.id && item.cellId === cell.id,
          );
        }
      });
    });
  }

  return {
    cloneBulkBeatChange,
    cloneResetBeats,
    cloneBeatChanges,
    cloneResetSwapList,
    cloneSwapBeatChanges,
    cloneBulkSwapChanges,
  };
};
